import React from "react";
import { tono } from "./tonos";

/**
 * Tarjeta semáforo del kit de tableros (Diego 2026-09-21): el total de una
 * clase a la izquierda y, ocupando el resto del ancho, una casilla GRANDE por
 * color con su número y lo que significa. El desglose por color es lo
 * accionable: no va en chips diminutos. Clic en el total o en una casilla =
 * filtro que abre el tracking (nunca lista filas).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-21
 * @param {string} titulo   Kicker de la tarjeta
 * @param {number} valor    Total de la clase
 * @param {string} nota     Texto bajo el total
 * @param {string} tonoxxx  Tono del total y de la barra superior
 * @param {boolean} activa  Resaltada (clase elegida)
 * @param {function} onClick Drill-down del total
 * @param {Array} casillas  [{clave, valor, etiqueta, nota, hex, sobre, onClick}] hex = color pleno, sobre = texto encima
 */
const Semaforx = ({ titulo, valor, nota, tonoxxx = "NAVY", activa = false, onClick, casillas = [] }) => {
  const t = tono(tonoxxx);
  return (
    <div className={`tbl-card tbl-kpi tbl-semaforo ${activa ? "activa" : ""}`}>
      <div className="tbl-kpi-barra" style={{ background: t.hex }} />
      <div className="tbl-semaforo-cabeza">
        <span className="tbl-semaforo-titulo">{titulo}</span>
        {nota && <span className="tbl-semaforo-nota">{nota}</span>}
      </div>
      <div className="tbl-semaforo-cuerpo">
        <button type="button" className="tbl-semaforo-total" onClick={onClick} title="Ver todas en su pantalla">
          <span className="tbl-semaforo-numero" style={{ color: tonoxxx === "NAVY" || tonoxxx === "GRIS" ? undefined : t.hex }}>{valor}</span>
          <span className="tbl-semaforo-total-etiqueta">en total</span>
        </button>
        <div className="tbl-semaforo-casillas" style={{ "--tbl-casillas": casillas.length || 4 }}>
          {casillas.map((casilla) => {
            const vacia = !(Number(casilla.valor) > 0);
            return (
              <button
                key={casilla.clave}
                type="button"
                className={`tbl-semaforo-casilla ${vacia ? "vacia" : ""}`}
                style={vacia ? { borderTopColor: casilla.hex } : { background: casilla.hex, color: casilla.sobre, borderTopColor: casilla.hex }}
                disabled={vacia}
                title={vacia ? `Sin ${casilla.etiqueta}` : `Ver las ${casilla.valor} ${casilla.etiqueta} en su pantalla`}
                onClick={(e) => {
                  e.stopPropagation();
                  casilla.onClick?.();
                }}
              >
                <span className="tbl-semaforo-casilla-numero">{casilla.valor}</span>
                <span className="tbl-semaforo-casilla-etiqueta">{casilla.etiqueta}</span>
                {casilla.nota && <span className="tbl-semaforo-casilla-nota">{casilla.nota}</span>}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Semaforx;
